import { Component, OnInit, OnDestroy, Injector } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { User } from 'src/app/components/catalogs/user-catalog/services/user';
import { BaseComponent } from 'src/app/common/base/base.component';
import { UsersRefresh } from '../catalogs/user-catalog/store/users.action';
import { LoginDialogService } from 'src/app/services/authentication/login-dialog.service';

@Component({
  selector: 'app-login',
  templateUrl: './login-dialog.component.html',
  styleUrls: ['./login-dialog.component.scss']
})

export class LoginDialogComponent
  extends BaseComponent
  implements OnDestroy, OnInit {

  public devMode = true;
  public toggleVisible: boolean = false;

  loading = false;
  submitted = false;

  dropdown = true;
  username = '';
  usernameCtrl = new FormControl();
  passwordCtrl = new FormControl();
  password = '';

  allUsers: User[] = [];
  usersFiltered: User[] = [];
  filterText = '';

  constructor(
    public login: LoginDialogService,
    private auth: AuthenticationService,
    public dialogRef: MatDialogRef<LoginDialogComponent>,
    protected override injector: Injector
  ) {
    super(injector);
    this.loading = false;

    this.devMode = !environment.isProduction;
    this.toggleVisible = environment.toggle;
    this.password = '';
  }

  ngOnInit() {
    this.store.dispatch(new UsersRefresh());
  }

  override usersLoaded(): void {
    this.allUsers = this.users.filter(u => u.status == 1);
    this.allUsers.map(u => {
      u.roleCodes = u.userRole?.map(r => r.role?.code).join(', ');
    });
    this.usersFiltered = this.allUsers;
    if (this.getCurrentUser()) {
      this.cancel;
      this.loading = false;
    }
  }

  toggle() {
    this.dropdown = !this.dropdown;
    if (this.dropdown) {
      this.getUsers();
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  filter(e?: any) {
    // Ignore arrow/enter keys: those navigate or pick an option, they don't change the search text.
    const code = e?.code;
    if (code?.includes('Arrow') || code?.includes('Enter')) return;
    // Normalize the typed text (trimmed, lowercase) and remember it so the template can highlight matches.
    const search = e?.target?.value?.trim().toLowerCase() ?? '';
    this.filterText = search;
    // No search text: show every user in the original alphabetical order.
    if (!search) {
      this.usersFiltered = this.allUsers;
      return;
    }
    // Keep users whose name or role codes contain the search text, then order the matches.
    this.usersFiltered = this.allUsers
      .filter(x => x.name?.toLowerCase().includes(search) || x.roleCodes?.toLowerCase().includes(search))
      // Earlier matches in the name rank first; equal ranks fall back to alphabetical order.
      .sort((a, b) =>
        this.matchRank(a.name, search) - this.matchRank(b.name, search) ||
        (a.name ?? '').localeCompare(b.name ?? ''));
  }

  // Returns where the search text appears in the name (0 = starts with it) so matches at the
  // front sort first. Names that don't contain the search (matched via role codes) sort to the end.
  private matchRank(name: string | undefined, search: string): number {
    const index = name?.toLowerCase().indexOf(search) ?? -1;
    return index < 0 ? Number.MAX_SAFE_INTEGER : index;
  }

  displayName(user: User): string {
    return user?.name ?? '';
  }

  select(user: User) {
    if (user) {
      this.loading = true;
      this.auth.authenticate(user).subscribe(response => {
        this.loading = false;
        this.dialogRef.close(response);
      }, error => {
        this.loading = false;
        console.log(error);
      });
    }
  }


}
